module.exports = __webpack_public_path__ + "static/cred_9001.89d01c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer/cred_9001.png
// module id = 1406
// module chunks = 168707334958949